import LoadStatsPage from './pages/LoadStats.page';
import LoadStatsBIPage from './pages/LoadStatsBI.page';
import TrailerDetailsPage from './pages/TrailerDetails.page';

LoadStatsPage.path = '/loads';
LoadStatsBIPage.path = '/loads/bi';
TrailerDetailsPage.path = '/trailers/:id';

export default {
  pages: {
    LoadStatsPage,
    LoadStatsBIPage,
    TrailerDetailsPage,
  },
};
